module.exports = __webpack_public_path__ + "static/media/trash-2-small.7d6a405e.svg";